import { IonContent, IonPage, IonButton, IonIcon } from "@ionic/react"
import Header from "../../../../components/header/Header"
import { calendarClearOutline, information, refresh } from "ionicons/icons"
import Placeholder from "../../../../components/placeholder/Placeholder"
import GridTable from '@nadavshaar/react-grid-table';
import './AgedReceivablesPage.scss';
import InputDate from "../../../../components/input-date/InputDate";
import { agedPayables, agedReceivables } from "../../../../graphql/report/queries";
import { useQuery } from "@apollo/client";
import { useAuth } from "../../../../context/auth/AuthState";
import { ListNoOptionsMessage } from "../../../../components/select-menu-components/SelectMenuComponents";
import { getAllVendorsQuery } from "../../../../graphql/vendor/queries";
import { getDate, parseDate } from "../../../../helpers/date";
import Select from 'react-select';
import { formatSelectData, generateYears, generateYearsReports } from "../../../../helpers/utils";
import { useForm } from "../../../../hooks/useForm";
import { useState } from "react";
import { sfnSelectTheme } from "../../../../theme/sfnSelectTheme";
import { getAllCustomersQuery } from "../../../../graphql/customer/queries";
import BreadCrumbs from "../../../../components/breadcrumbs/BreadCrumbs";

const initialState = {
  year: { value: new Date().getFullYear(), label: new Date().getFullYear() },
  from: getDate(new Date(new Date().getFullYear(), 0, 1), false),
  to: getDate(new Date(new Date().getFullYear(), 11, 31), false),
  customerId: '',
  min: `${new Date().getFullYear()}-01-01`,
  max: `${new Date().getFullYear()}-12-31`,
}

const AgedReceivablesPage = () => {
  const { formValues, handleInputChange, reset } = useForm(initialState);
  const { year, from, to, customerId, min, max } = formValues;
  const [filter, setFilter] = useState({ customerId, from, to })
  const { data, loading, error, refetch } = useQuery(agedReceivables, { variables: { ...filter }, fetchPolicy: 'cache-and-network' });
  const { data: allCustomer, loading: customersLoading, error: customersError, refetch: refetchCustomers } = useQuery(getAllCustomersQuery);

  const { authState } = useAuth();
  const { enterprise } = authState;

  const columns = [
    {
      id: 1,
      field: 'name',
      label: ' ',
      width: '155px'
    },
    {
      id: 2,
      field: 'noYetOverdue',
      label: 'Aún no vencido',
      headerCellRenderer: () => (<div className="m-auto">Aún no vencido</div>),
      width: '150px',
      cellRenderer: ({ data }) => {
        return (
          <div className="text-right w-full m-4">
            <p>{enterprise?.currency?.symbol}{data.noYetOverdue} {enterprise?.currency?.code}</p>
          </div>)
      }
    },
    {
      id: 3,
      field: '_30OrLess',
      label: '30 o menos',
      headerCellRenderer: () => (<div className="aged-receivable-cell-color">30 o menos</div>),
      width: '150px',
      cellRenderer: ({ data }) => {
        return (
          <div className="text-right w-full m-4">
            <p>{enterprise?.currency?.symbol}{data._30OrLess} {enterprise?.currency?.code}</p>
          </div>)
      }
    },
    {
      id: 4,
      field: '_31To60',
      label: '31 a 60',
      headerCellRenderer: () => (<div className="aged-receivable-cell-color">31 a 60</div>),
      width: '150px',
      cellRenderer: ({ data }) => {
        return (
          <div className="text-right w-full m-4">
            <p>{enterprise?.currency?.symbol}{data._31To60} {enterprise?.currency?.code}</p>
          </div>)
      }
    },
    {
      id: 5,
      field: '_61To90',
      label: '61 a 90',
      headerCellRenderer: () => (<div className="aged-receivable-cell-color">61 a 90</div>),
      width: '150px',
      cellRenderer: ({ data }) => {
        return (
          <div className="text-right w-full m-4">
            <p>{enterprise?.currency?.symbol}{data._61To90} {enterprise?.currency?.code}</p>
          </div>)
      }
    },
    {
      id: 6,
      field: '_91OrMore',
      label: '91 a más',
      headerCellRenderer: () => (<div className="aged-receivable-cell-color">91 a más</div>),
      width: '150px',
      cellRenderer: ({ data }) => {
        return (
          <div className="text-right w-full m-4">
            <p>{enterprise?.currency?.symbol}{data._91OrMore} {enterprise?.currency?.code}</p>
          </div>)
      }
    },
    {
      id: 7,
      field: 'total',
      label: 'Total no pagado',
      headerCellRenderer: () => (<div className="ml-auto mr-2">Total no pagado</div>),
      width: '155px',
      cellRenderer: ({ data }) => {
        return (
          <div className="text-right w-full m-4">
            <p>{enterprise?.currency?.symbol}{data.total} {enterprise?.currency?.code}</p>
          </div>)
      }
    },
  ]
  const tableProps = {
    showSearch: false,
    showRowsInformation: false,
    isPaginated: false,
    showColumnVisibilityManager: false
  }

  const handleInputChangeSelect = (e, key) => {
    console.log(e, key)
    if (!key) {
      let { value, name } = e.target;
    } else {
      if (key == 'year') {
        if (e !== null) {
          handleInputChange(`${e?.value}-01-01`, 'min')
          handleInputChange(`${e?.value}-12-31`, 'max')
          handleInputChange(`${e?.value}-01-01`, 'from')
          handleInputChange(`${e?.value}-12-31`, 'to')
        } else {
          handleInputChange('', 'from')
          handleInputChange('', 'to')
        }
      }
      handleInputChange(e, key)
    }
  }

  const handleFilters = () => {
    setFilter({ from: from !== '' ? from : undefined, to: to !== '' ? to: undefined, customerId: customerId?.value || undefined })
  }

  const breads = [{
    title: 'Reportes',
    url: '/reports',
  }, {
    title: 'Cuentas por cobrar',
    url: '/reports/aged-receivables'
  }];


  return (
    <IonPage id="aged-receivables-page">
      <Header title="Cuentas por cobrar"></Header>

      <IonContent className="sfn-content">
        <BreadCrumbs className="md:-ml-6 ml-0 mb-12" breads={breads} />

        <section className="flex w-full flex-col sm:flex-row justify-between mb-12 md:items-center items-start" >
          <div className="md:w-80 w-full">
            <p className="text-sm mb-2 hover:text-secondary w-80">Año</p>
            <div className="flex items-center dropdown-month">
              <IonIcon slot="start" icon={calendarClearOutline} className="pr-2 text-2xl" />
              <Select isClearable={true} placeholder="Seleccione el año" value={year} options={generateYearsReports(new Date('1900-01-01'))} onChange={e => (handleInputChangeSelect(e, 'year'))} className="sfn-select md:w-60 w-full z-20" styles={sfnSelectTheme} />
            </div>
          </div>
          <InputDate min={min} max={max} className="" label="Desde" value={from} onChange={handleInputChange} name="from" icon={false} />
          <InputDate min={min} max={max} className=" md:mb-0 mb-2" label="Hasta" value={to} onChange={handleInputChange} name="to" icon={false} />
          <div className="md:w-80 w-full">
            <p className="text-sm mb-2 hover:text-secondary w-80">Cliente</p>
            <div className="flex items-center dropdown-month">
              <Select isClearable={true} placeholder="Seleccione el cliente" value={customerId} options={formatSelectData({ value: 'id', label: 'name' }, allCustomer?.customers?.rows)} onChange={e => (handleInputChangeSelect(e, 'customerId'))} className="sfn-select md:w-60 w-full z-20" styles={sfnSelectTheme}
                components={
                  {
                    // MenuList: (props) => MenuListButton({...props, label:"Agregar nuevo proveedor", callback:setShowVendorModal}),
                    NoOptionsMessage: (props) => ListNoOptionsMessage({ ...props, label: "No hay clientes" })
                  }
                } />
            </div>
          </div>
          <IonButton className="sfn-button md:mt-0 mt-8 sm:w-auto w-full" shape="round" onClick={handleFilters}>
            <IonIcon slot="start" icon={refresh} />
            Actualizar reporte
          </IonButton>
        </section>
        <section className="aged-receivable-table-title mt-20">
          <h3 className="font-bold text-base text-gray-blue sm:text-2xl mb-10">Período de {parseDate(filter.from).replace(/\//g, '-')} a {parseDate(filter.to).replace(/\//g, '-')} </h3>
          <p>Número de días vencidos</p>
        </section>
        <GridTable className="sfn-data-table no-cell-padding pt-1"
          columns={columns}
          rows={data?.agedReceivables}
          isLoading={false}
          components={{
            NoResults: () => (
              <Placeholder icon={information} description='No tienes información de cuentas por cobrar
              en el período de tiempo seleccionado.' />
            )
          }}
          {...tableProps}
        />
      </IonContent>
    </IonPage>
  )
}

export default AgedReceivablesPage
